"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "monte-san-giovanni-campano": {
    "02ad763b": [{
      "hkey": "344e28de",
      "slug": "anitrella-chiaiamari",
      "name": "Anitrella-Chiaiamari",
      "primary": true,
      "skipSearch": false
    }],
    "anitrella": [{
      "hkey": "344e28de",
      "slug": "anitrella-chiaiamari",
      "name": "Anitrella-Chiaiamari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fd0d3d1f": [{
      "hkey": "344e28de",
      "slug": "anitrella-chiaiamari",
      "name": "Anitrella-Chiaiamari",
      "primary": true,
      "skipSearch": false
    }],
    "chiaiamari": [{
      "hkey": "344e28de",
      "slug": "anitrella-chiaiamari",
      "name": "Anitrella-Chiaiamari",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "monte-san-giovanni-campano"
    }]
  }
};
exports["default"] = _default;